import Header from './src/header.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpHeader = withInstall(Header)
export default EpHeader
export * from './src/header'

